import React from 'react';
export function Spinner({
  size = 40
}: {
  size?: number;
}) {
  return <span role="status" aria-label="Loading" className="inline-block animate-spin rounded-full border-[3px] border-ink-200 border-t-emerald-500" style={{
    width: size,
    height: size
  }} data-id="element-394" data-mp="3hp4i6skpzth7" />;
}
export function FullPageLoader() {
  return <div className="flex flex-1 items-center justify-center bg-white" data-id="element-395" data-mp="37srq1z4tpnok">
      <Spinner data-id="element-396" data-mp="989rebh75zjh" />
    </div>;
}